import support from '../../services/support'
import { i18n } from '../../main'
import moment from "moment"
const packageVersion =  window.configs && window.configs.PACKAGE_VERSION !== "" 
? window.configs.PACKAGE_VERSION: process.env.PACKAGE_VERSION;
function initState() {
    let title = ''
    let body = '';
    let agencyInfo = {}; 
    let reasons = []
    let recipients = []
    return {
        title,
        body,
        reasons,
        agencyInfo,
        recipients,
        packageVersion: packageVersion || '0'
    }
}

function fillTitle(template, payload) {
    const {
        firstName,
        name,
        reason,
        title
    } = payload
    return (
        template
            .replace('[user:name]', `${firstName} ${name}`)
            .replace('[input:reason]', reason)
            .replace('[input:title]', title)
    )
}

function fillBody(template, payload) {
    const {
        firstName,
        name,
        email,
        reason,
        title,
        messages,
        versionApp,
        agencyName,
        device,
        browser,
        pkAdv,
        pointings
    } = payload
    const formatMsg = `<div style='white-space:pre;overflow-wrap:break-word;word-break:break-word;'>${messages}</div>`
    return (
        template
            .replace('[user:name]', `${firstName} ${name}`)
            .replace('[user:email]', email)
            .replace('[input:reason]', reason)
            .replace('[Input title from the user]', title)
            .replace('[Input messages from the user]', formatMsg)
            .replace('[VersionApp]', versionApp)
            .replace('[VersionOS]', browser)
            .replace('[Model]', device)
            .replace('Version de l\'application', 'Version de site')
            .replace('Modèle de téléphone', 'Modèle de ordinateur')
            .replace('Version de l\'OS', 'Version de navigateur')
            .replace('[AgencyName]', agencyName ? `Vitalliance ${agencyName}` : '')
            .replace('[PKNagora]', pkAdv)
            .replace('[pointings]', showPointings(pointings) || '')
    )
}

function showPointings(pointings) {
    if (pointings.length) {
        const histories = []
        pointings.forEach(element => {
            const typePointage = element.typePointage === 1 ? i18n.t('pointing-history-view-begin-label') : i18n.t('pointing-history-view-end-label')
            const pointing = `<div style='display: flex'><p style='width:15%; margin: 0px 0px 0px 20px'>${typePointage}</p><p style='width:45%; margin: 0px 10px'>${element.clientName}</p><p style='width:40%; margin: 0px'>${moment(element.horodatage).format('DD / MM / YYYY – HH:mm')}</p></div>`
            histories.push(pointing)
        });
        return histories.join('')
    // } else {
    //     const noData = i18n.t('no-data')
    //     return `<span>${noData}</span>`
    }
}

export default {
    namespaced: true,
    state: initState(),
    mutations: {
        SET_TITLE(state, title) {
            state.title = title
        },
        SET_BODY(state, body) {
            state.body = body
        },
        SET_REASONS(state, reasons) {
            const reworkReasons = reasons.map(r => {
                return {
                    value: r.text,
                    text: r.text
                }
            })
            state.reasons = reworkReasons
        },
        SET_RECIPIENTS(state, recipients) {
            const reworkRecipients = recipients.map(r => {
                return {
                    value: r.emailAddress,
                    text: r.emailAddress
                }
            })
            state.recipients = reworkRecipients
        },
        SET_ANGENCY_INFO: (state, agencyInfo) => {
            state.agencyInfo = agencyInfo;
        }
    },
    actions: {
        async init(store) {
            const tsClaime = await support
                .get('ts')
                .catch(
                    () => undefined
                )
            if (tsClaime) {
                store.commit('SET_TITLE', tsClaime.title)
                store.commit('SET_BODY', tsClaime.content)
                store.commit('SET_REASONS', tsClaime.reasons)
                store.commit('SET_RECIPIENTS', tsClaime.recipient)
            }
        },
        async send(store, payload) {
            const title = fillTitle(store.getters.title, payload)
            const message = fillBody(store.getters.body, payload)
            const body = {
                title: title,
                from: payload.email,
                to: store.getters.recipients.map(email =>  {
                    if(email.value === '{agencyEmail}' && store.state.agencyInfo) {
                        email.value = store.state.agencyInfo.email;
                    }
                    return email.value
                }),
                message: message
            };

            return new Promise((resolve, reject) => {
                support.claim(body).then(res => {
                    res.success ? resolve(res) : reject(false);
                }).catch(err => {
                    reject(err);
                })
            });
        },
        getAgencyInfo(store, agencyInfo) {
            store.commit('SET_ANGENCY_INFO', agencyInfo);
        },
    },
    getters: {
        title: state => state.title,
        body: state => state.body,
        reasons: state => state.reasons,
        recipients: state => state.recipients,
        appVersion: state => state.packageVersion,
        agencyInfo: (state) => state.agencies

    }
}